import { BaseSurvey } from '../base-survey';
import { AssetLibraryPickerSurveyView } from './view';
import { validateAssetLibraryTriggerCondition } from '../utils';

export class AssetLibraryPickerSurvey extends BaseSurvey {
  getSurveyName = () => 'AssetLibraryPickerSurvey';

  getSurveyId = isTestEnv => (isTestEnv ? 'cfa725ec-eec1-4333-a7b3-d6b208ac2358' : 'ec9fe9b2-2ffe-4b60-80ff-e3f553b3d85f');

  validateTriggerCondition = () => validateAssetLibraryTriggerCondition(this, 'AssetLibraryPickerSurveyTrigger');

  onSurveySubmit() {
    window.survey.AssetLibraryPickerSurveyTrigger = false;

    super.onSurveySubmit();
  }

  onSurveyDismiss() {
    window.survey.AssetLibraryPickerSurveyTrigger = false;

    super.onSurveyDismiss();
  }

  getSurveyComponent = () => AssetLibraryPickerSurveyView;
}
